var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    width: 14,
    height: 14,
    style: {
      borderColor: "rgba(187,187,187,1)",
      borderWidth: 0,
      borderStyle: "solid"
    },
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M894.976 0C966.144 0 1024 57.856 1024 129.024v283.136c0 16.896-13.824 30.72-30.72 30.72s-30.72-13.824-30.72-30.72V129.024c-0.512-37.376-30.208-67.072-67.584-67.584h-762.88c-36.864 0.512-67.072 30.72-67.584 67.584v762.88c0.512 36.864 30.72 67.072 67.584 67.584h283.136c16.896 0 30.72 13.824 30.72 30.72s-13.824 30.72-30.72 30.72H131.584C60.416 1020.928 2.56 963.072 2.56 891.904v-762.88C3.072 57.856 60.928 0 131.584 0h763.392",
    "p-id": 105297,
    fill: "rgba(19.89,107.1,255,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.24 256c54.272 0 106.496 16.384 150.528 48.128 117.76 83.456 146.432 246.784 62.976 365.056l-14.336 20.48 17.92 17.92 183.808 183.808 0.512 0.512 0.512 0.512 1.536 1.536c10.24 11.264 9.728 28.672-1.536 39.424-5.12 4.608-11.776 7.68-18.944 7.68-7.68 0-14.848-3.072-20.48-8.704l-0.512-0.512-0.512-0.512-185.856-185.856-16.896-18.432-19.968 12.288c-41.472 26.112-89.6 39.936-138.752 39.936-54.272 0-106.496-16.384-151.04-48.128-117.76-83.456-146.432-246.784-62.976-365.056C356.864 297.472 437.248 256 522.24 256m2.048 467.968c111.616 0 202.24-90.624 202.24-202.24s-90.624-202.24-202.24-202.24-202.24 90.624-202.24 202.24c0.512 111.616 91.136 202.24 202.24 202.24",
    "p-id": 105298,
    fill: "rgba(19.89,107.1,255,1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.f80b95bb.svg";
export { ForwardRef as ReactComponent };